// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.j1Zq3BmKOl8GTy {
  max-width: 30%;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin: 30px auto;
}
.eatNMYqig3qHhR > span {
  display: flex;
  align-items: center;
  margin-right: var(--ds-space-negative-075, -5px);
}
`, ""]);
// Exports
export var errContainer = `j1Zq3BmKOl8GTy`;
export var learnHow = `eatNMYqig3qHhR`;
export default ___CSS_LOADER_EXPORT___;
